import * as actions from 'actions';
import {browserHistory} from 'react-router';
import {getClientCredential, getCreditNoteRedirectStorage, setCreditNoteRedirectStorage, getLocalStorageAuth, getSubscriptionsRedirectStorage, setSubscriptionsRedirectStorage} from 'PaymentAPI';
import { setSelectedOrganization } from 'TamtamAPI';

import { setCookie, setAuthCookie, getCookie, getAuthInfos } from 'utils';
import { APP_ENV } from 'Config';


import {
  fetchAuthUser,
  setAuthToken,
  setExpiresIn,
  setLanguage,
  setTokenCreatedAt,
  setAuth
} from 'actions';
import {getClients, getTTPUser} from 'TamtamAPI';
import * as api from "../../api";

export const setAuthUser = (user, loggedWithToken = false) => {
  return (dispatch, getState) => {
    dispatch(actions.setAuthToken(user.token));
    dispatch(setAuthToken(user.token));
    dispatch(setExpiresIn(user.expiresIn));
    dispatch(setTokenCreatedAt(user.createdAt));

    if(loggedWithToken === true){
      dispatch(actions.setLanguage(user.language));
      return dispatch(actions.setUserLoggedWithToken(user));
    }

    return dispatch(actions.fetchAuthUser(
      getTTPUser(user.id, user.token).then((res) => {
        const user = res.data.data[0];
        dispatch(actions.setLanguage(user.language));
        const uri = getCreditNoteRedirectStorage();
        const subscriptionUri = getSubscriptionsRedirectStorage();
        if(uri) {
          location.href = uri;
        }

        if(subscriptionUri) {
          location.href = subscriptionUri;
        }

        setCreditNoteRedirectStorage(null);
        setSubscriptionsRedirectStorage(null);
        return user;
      }, err => err),
    ));
  };
};

export const setCurrentClient = client => (dispatch, getState) => {
  const {token} = getState().auth;

  return dispatch(actions.setCurrentClient(
    setSelectedOrganization(token, client).then(() => {
      const dtExpire = new Date();
      dtExpire.setTime(dtExpire.getTime() + 86400 * 3);
      setCookie(`ttp_community_${APP_ENV}`, client.id, dtExpire, '/', 'tamtam.pro');
      return client;
    }, err => err)))
};


export const loginWithToken = (token) => {

  return async (dispatch, getState) => {
    // const currentUser = getState().auth.user;
    // const currentUserId = currentUser ? currentUser.id : 0;

    const fetchUser = async () => {
      try {
        const response = await api.fetchTTPUserByToken(token);
        return response.data.data;
      } catch (e) {
        return null;
      }
    };
    const user = await fetchUser();

    if (user) {
      const {authInfos , expired} = getAuthInfos('ttp_auth_'+APP_ENV);
      let auth = getLocalStorageAuth();
      let isAuthExpired = true;
      if (authInfos && !expired && auth && auth.user != null && authInfos.token === auth.token) {
        isAuthExpired = false;
      }

      const currentUserId = auth && auth.user ?  auth.user.id  : 0;

      if (user.id != currentUserId || isAuthExpired) {
        dispatch(setAuthUser({...user , token : user.token.access_token, expiresIn : String(user.token.expires) , createdAt : String(+user.token.expires * 1000 - new Date().getTime())}, true));
        setAuthCookie(user);
      } else {

        auth.redirectUrl = getState().auth.redirectUrl;

        dispatch(setAuth(auth));
        return ;
      }
    }else {

      // Logout
    }
  }
};



// WEBPACK FOOTER //
// ./app/actions/thunks/auth.js